
<div class="mat-table orders-table">
    <h2 class="text-muted ">Warranty Details</h2>
    <div class="mat-header-row">
      <div class="mat-header-cell">User Name</div>
      <div class="mat-header-cell">ImplementId</div>
      <div class="mat-header-cell">SerialNumber</div>
      <div class="mat-header-cell ">DelearCode </div>
      <div class="mat-header-cell ">ImplementPurchaseDate</div>
    </div>
    <div  *ngFor="let warrantyinfo of WarrantyList" class="mat-row">
      <div class="mat-cell">{{warrantyinfo.userName}}</div>
      <div class="mat-cell">{{warrantyinfo.implementId}}</div>
      <div class="mat-cell">{{warrantyinfo.serialNumber}}</div>
      <div class="mat-cell">{{warrantyinfo.delearCode}}</div>
      <div class="mat-cell"> {{warrantyinfo.implementPurchaseDate}}</div> 
    </div>
  </div>
